/* ============================================================
   REKOVA — script partagé
   → devient assets/rekova.js dans Shopify
   ============================================================ */
(function(){
  var ZONES = ["Le pied","La cheville","Le bas du mollet","Le haut du mollet",
               "Le genou","Le bas de la cuisse","Le milieu de la cuisse","Le haut de la cuisse"];

  var GRAD = '<defs><linearGradient id="sg" x1="0" y1="1" x2="0" y2="0">'
           + '<stop offset="0%" stop-color="#FF5C43"/><stop offset="100%" stop-color="#4FD8C4"/></linearGradient></defs>';

  /* Dessine une botte. active = tableau de 8 booléens. wave = index de la vague (0 = aucune) */
  function boot(x, active, wave){
    var H = [30,26,26,26,26,26,26,32], W = [52,56,60,64,66,68,70,70];
    var y = 26, out = '';
    for (var i = 7; i >= 0; i--){
      var n = i + 1, w = W[i], h = H[i], px = x + (72 - w) / 2;
      var on = active ? active[i] : true;
      var fill = !on ? '#DFE6E9' : (wave && n <= wave ? 'url(#sg)' : '#16262D');
      var r = (i === 7 || i === 0) ? 6 : 4;
      out += '<rect x="'+px+'" y="'+y+'" width="'+w+'" height="'+(h-4)+'" rx="'+r+'" fill="'+fill+'"/>';
      y += h;
    }
    return '<g>'
      + '<rect x="'+(x+2)+'" y="22" width="68" height="'+(y-20)+'" rx="10" fill="#0F2028"/>'
      + out
      + '<rect x="'+(x+34)+'" y="28" width="3" height="'+(y-36)+'" rx="1.5" fill="#33505C"/>'
      + '<path d="M'+(x+4)+' '+(y+2)+' h64 a8 8 0 0 1 8 8 v10 a6 6 0 0 1 -6 6 h-72 a6 6 0 0 1 -6 -6 v-10 a8 8 0 0 1 8 -8 z" fill="#0F2028"/>'
      + '</g>';
  }

  function pair(active, wave, vb){
    return '<svg viewBox="'+(vb||'0 0 200 280')+'" xmlns="http://www.w3.org/2000/svg">'
         + GRAD + '<g transform="translate(24,4)">' + boot(0, active, wave) + boot(80, active, wave) + '</g></svg>';
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero : vague continue ---- */
  var hv = document.getElementById('heroVis');
  if (hv){
    var hw = 0;
    function drawHero(){ hv.innerHTML = pair(null, hw); }
    drawHero();
    if (!reduce) setInterval(function(){ hw = hw % 9 + 1; if (hw === 9) hw = 0; drawHero(); }, 620);
  }

  /* ---- Carte produit ---- */
  var pv = document.getElementById('pcVis');
  if (pv) pv.innerHTML = pair(null, 0);

  /* ---- Contrôle par zone ---- */
  var chips = document.getElementById('chips');
  var ctlVis = document.getElementById('ctlVis');
  var count = document.getElementById('ctlCount');
  var pr = document.getElementById('pr');
  var prVal = document.getElementById('prVal');

  if (chips && ctlVis){
    var active = [true,true,true,true,true,true,true,true];
    var wave = 0, wtimer;

    ZONES.forEach(function(z, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rk-chip';
      b.setAttribute('aria-pressed','true');
      b.innerHTML = '<span class="rk-dot"></span><span><span class="rk-chip-n">0'+(i+1)+'</span><br>'
                  + '<span class="rk-chip-t">'+z+'</span></span>';
      b.addEventListener('click', function(){
        active[i] = !active[i];
        b.classList.toggle('rk-off', !active[i]);
        b.setAttribute('aria-pressed', String(active[i]));
        render();
      });
      chips.appendChild(b);
    });

    function render(){
      ctlVis.innerHTML = pair(active, wave, '0 0 200 280');
      var n = active.filter(Boolean).length;
      count.textContent = n + ' / 8';
    }

    if (pr){
      pr.addEventListener('input', function(){ prVal.textContent = pr.value + ' mmHg'; });
    }

    render();
    if (!reduce){
      wtimer = setInterval(function(){
        wave = wave % 9 + 1;
        if (wave === 9) wave = 0;
        render();
      }, 700);
    }
  }

  /* ---- FAQ ---- */
  document.querySelectorAll('.rk-q').forEach(function(q){
    q.addEventListener('click', function(){ q.classList.toggle('rk-open'); });
  });
})();